import { useState } from "react";
import style from "./../ClientBook.module.scss";
import { FaChevronUp } from "react-icons/fa";
import Loader from "components/miscellaneous/Loader/Loader";
import { useEffect } from "react";

const StepSkeleton = ({ number, title, getContent, getSummary, getData, show, complete, canContinue, continueLabel, continueButton, submit, isCompleted }) => {
    const [ completed, setCompleted ] = useState(isCompleted !== undefined ? isCompleted : false);
    const [ isLoading, setIsLoading ] = useState(false);

    const completeStep = async(num = null) => {
        if (num === null) {
            try {
                if(submit) {
                    setIsLoading(true)
                    const res = await submit();
                    // console.log(res)
                }
                setCompleted(true);
            } catch(e) {

            } finally {
                setIsLoading(false)
            }
        }

        const data = getData !== undefined ? getData() : {}
        complete(num, data)
    }

    useEffect(() => {
        if(isCompleted !== undefined) {
            setCompleted(isCompleted)
        }
    }, [isCompleted])

    return (
        <section className={ [ style.step, !show && style.minimized, completed && style.completed ].join(' ') }>
            { isLoading && <div className={ style.loading }>
                <Loader color="#ddd" />
            </div> }
            <div className={ style.stepContent }>
                <div className={ style.stepHeader } onClick={ (e) => {
                    if (completed && !show) {
                        completeStep(number - 1)
                    }
                } }>
                    <span>{ number }</span>
                    <div>
                        <h3>{ title }</h3>
                        { (!show && completed) && <p className={ style.completedStep }>
                            { getSummary !== undefined && getSummary() }
                        </p> }
                    </div>
                    { completed && <div className={ style.stepArrow }>
                        <FaChevronUp />
                    </div> }
                </div>
                <div className={ style.stepInnerContent }>
                    { getContent() }
                    { continueButton !== false && <button disabled={ !canContinue() } className={ style.confirmButton } onClick={ (e) => {
                        completeStep()
                    } }>{ continueLabel }</button> }
                </div>
            </div>
        </section>
    )
}

export default StepSkeleton;